import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import CheckBox from '../../Default/CheckBox';
import AssetPickerLink from '../../AssetPicker/AssetPickerLink';

import LibraryTypeEnum from '../../../../Game/Base/Library/Enums';

export default function Reaction({ points, health, sound, toLevel, updateBlokStateActionReaction, selectActionReactionForward }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row side-bar-row-title">Punten</div>
            <div className="side-bar-row">
                <RangeSlider
                    description={v => {
                        if (v === 0) {
                            return 'Geen effect';
                        }
                        if (v > 0) {
                            return `+${v}`;
                        }
                        return `${v}`;
                    }}
                    currentValue={points}
                    min={-100}
                    max={100}
                    step={1}
                    sliderStep={5}
                    onChange={v => {
                        updateBlokStateActionReaction({
                            points: v
                        });
                    }}
                />
            </div>
            <div className="side-bar-row side-bar-row-title">Gezondheid</div>
            <div className="side-bar-row">
                <RangeSlider
                    description={v => {
                        if (v === 0) {
                            return 'Geen effect';
                        }
                        if (v > 0) {
                            return `+${v}%`;
                        }
                        return `${v}%`;
                    }}
                    currentValue={health}
                    min={-100}
                    max={100}
                    step={1}
                    sliderStep={5}
                    onChange={v => {
                        updateBlokStateActionReaction({
                            health: v
                        });
                    }}
                />
            </div>
            <div className="side-bar-row side-bar-row-title">Finishen</div>
            <div className="side-bar-row">
                <CheckBox
                    name="toLevel"
                    checked={toLevel}
                    onChange={() =>
                        updateBlokStateActionReaction({
                            toLevel: !toLevel
                        })
                    }
                >
                    Naar volgend level
                </CheckBox>
            </div>
            <div className="side-bar-row side-bar-row-title">Laat een ander blok reageren</div>
            <div className="side-bar-row">
                <div onClick={selectActionReactionForward} className="side-bar-button">
                    Kies een blok
                </div>
            </div>
            <div className="side-bar-row side-bar-row-title">Geluid</div>
            <div className="side-bar-row">
                <AssetPickerLink
                    id="action-reaction-sound-picker"
                    type={LibraryTypeEnum.SOUNDS}
                    postCheckbox="Kies een geluid"
                    currentAsset={sound}
                    onPickAsset={s =>
                        updateBlokStateActionReaction({
                            sound: s
                        })
                    }
                />
            </div>
        </div>
    );
}
